var map = {
	"./en/1-5/tit.png": 23117,
	"./fi/1-5/tit.png": 19123,
	"./in/1-5/tit.png": 59553,
	"./th/1-5/tit.png": 47128,
	"./tw/1-5/tit.png": 45279,
	"./zh/1-5/tit.png": 50238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33253;